/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component} from '@angular/core';
import template from './team-group-item-page.component.html';

import {AdminResourceItemPageBase} from '../../common/controller/admin-resource-item-page-base';

@Component({
  standalone: false,
  selector: 'adn-team-group-item-page',
  template
})
export class TeamGroupItemPageComponent extends AdminResourceItemPageBase {
  constructor(cdr: ChangeDetectorRef) {
    super(cdr);
  }
}
